'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import { SandwichIcon, CrossIcon } from '@avtopro/icons';
import LocaleLink from '@/components/LocaleLink';
import { useTranslations } from 'next-intl';
import classNames from 'classnames';
import useAnalytics from '@/utils/analytics';
import { usePathname } from 'next/navigation';

interface HeaderProps {
	locale: string;
	referrer: string;
	theme?: 'light' | 'dark';
}

const Header = ({ locale, referrer, theme = 'dark' }: HeaderProps) => {
	const pathName = usePathname();
	const [navVisible, setNavVisible] = useState(false);
	const t = useTranslations('Header');
	const analytics = useAnalytics({
		pushPageView: false,
		referrer: referrer,
	});
	const linksArray = [
		{ href: '/blog/', anchor: t('blog') },
		{ href: '/about/', anchor: t('aboutProject') },
		{ href: '/programs/', anchor: t('programs') },
		{ href: '/contacts/', anchor: t('contacts') },
	];

	return (
		<header className={`${theme}-mode light-mode:bg-white w-full bg-black`}>
			<nav className="page-container light-mode:bg-white relative flex flex-row items-center justify-between bg-black py-2">
				<LocaleLink
					className={classNames('block h-fit w-fit p-0 text-xl text-black', {
						['btn cursor-pointer']: pathName != '/',
					})}
					onClick={() =>
						analytics?.pushEvent('page:clickToHeader', {
							blockTitle: 'mainPage',
						})
					}
					href="/"
					isActive={pathName != '/'}
					locale={locale}>
					<Image
						src={
							theme == 'dark'
								? '/autoparts-wiki-logo.svg'
								: '/autoparts-wiki-logo-dark.svg'
						}
						alt={t('logoAlt')}
						loading={'eager'}
						width={170}
						height={35}
						unoptimized
					/>
				</LocaleLink>
				<div className="flex items-center" >
					{/*
					<button
						className="btn btn-accent h-fit! px-2 py-2 max-md:ml-2 max-md:text-[12px] md:px-4"
						onClick={handleClickContacts}>
						{t('connection')}
					</button>
					*/}
					<div
						className={classNames(
							'light-mode:bg-white absolute left-0 top-full z-10 rounded-b bg-black max-md:w-full max-md:text-center md:contents',
							{
								['max-md:hidden']: !navVisible,
							}
						)}>
						{linksArray.map(({ href, anchor }) => (
							<LocaleLink
								onClick={() =>
									analytics?.pushEvent('page:clickToHeader', {
										blockTitle: anchor,
									})
								}
								key={href}
								className="btn light-mode:text-black w-fit px-5 max-md:w-full"
								href={href}
								locale={locale}
								isActive={pathName !== href}>
								{anchor}
							</LocaleLink>
						))}
					</div>
					<button
						className="btn light-mode:text-black p-[11px_15px] md:ml-2 md:hidden"
						onClick={() => setNavVisible((prev) => !prev)}
						onBlur={() => setTimeout(() => setNavVisible(false))}
						name={t(navVisible ? 'closeNavMenu' : 'openNavMenu')}
						value={t(navVisible ? 'closeNavMenu' : 'openNavMenu')}
						aria-label={t(navVisible ? 'closeNavMenu' : 'openNavMenu')}>
						{navVisible ? (
							<CrossIcon className="light-mode:text-black text-white" />
						) : (
							<SandwichIcon className="light-mode:text-black text-white" />
						)}
					</button>
				</div>
			</nav>
		</header>
	);
};
export default Header;
